import React from 'react';
import { AssistantIcon } from '../../../assets';
import { ConversationCardProps } from './conversationModels';
import { formatFullDateTime } from '../../../helpers/dateHelpers';

const ConversationCard: React.FC<ConversationCardProps> = ({
  chat,
  campaignName,
}) => {
  const botMessagesCount = chat?.botMessagesCount || 0;
  // Meta Messenger chats have no campaign; the backend sends their effective
  // limit as replyLimit.
  const aiTalkLimit = chat?.replyLimit || chat?.Campaign?.aiTalkLimit || 30;
  const isLimitReached = botMessagesCount >= aiTalkLimit;

  let statusText = 'AI Active';
  let statusColor = '#34c759';
  let dotClass = 'bg-34c759';

  if (chat?.responseType === 'MANAGER') {
    if (isLimitReached) {
      statusText = 'Human Required';
      statusColor = '#ff3b30';
      dotClass = 'bg-ff3b30';
    } else {
      statusText = 'Human Active';
      statusColor = '#9ea4ac';
      dotClass = 'bg-9ea4ac';
    }
  }

  return (
    <div className="d-flex-start-start w-100 m-0_5rem-0 p-1_125rem-1_375rem bg-white b-radius-1_25rem b-1">
      <div className="d-flex-row-space-between w-100 pb-1rem" style={{ alignItems: 'center' }}>
        <div className="d-flex-row" style={{ alignItems: 'center' }}>
          <span className="ff-roboto c-50b5ff fs-1_125rem fw-600 ls-0_00625rem ">
            {chat?.Campaign?.name || campaignName
              ? `Campaign name: ${chat?.Campaign?.name || campaignName}`
              : 'Meta Messenger'}
          </span>
          {!chat?.lastMessage?.isSeen && (
            <div className="d-flex-center bg-34c759 w-0_75rem h-0_75rem b-radius-0_375rem ml-0_5rem"></div>
          )}
        </div>

        <div className="d-flex-row p-0_125rem-0_625rem b-radius-2_125rem b-1 bg-f9fafb" style={{ alignItems: 'center', marginBottom: '0.125rem' }}>
          <div
            className={`d-flex-center w-0_5rem h-0_5rem b-radius-0_25rem mr-0_375rem ${dotClass}`}
          ></div>
          <span
            className="ff-roboto fs-0_75rem fw-600"
            style={{
              textTransform: 'uppercase',
              letterSpacing: '0.025rem',
              color: statusColor,
              lineHeight: '1.2'
            }}
          >
            {statusText}
          </span>
        </div>
      </div>
      <div className="d-flex-row-space-between w-100 pb-1rem bb-1">
        <div className="d-flex-row ">
          <div className="d-flex-center bg-f1f1f5 w-3rem h-3rem b-radius-1_5rem mr-1_25rem">
            <AssistantIcon className="w-1rem" />
          </div>
          <h4 className="ff-poppins c-regular fs-1_125rem fw-600">
            Conversation with {chat?.Lead?.firstname} {chat?.Lead?.lastname}
          </h4>
        </div>
        <div className="d-flex-row">
          <div className="d-flex-center mr-1rem b-1 p-0_25rem-1rem b-radius-2_125rem">
            <span className="f-roboto-primary fs-0_875rem lh-1_5rem">
              {chat?.Lead?.email || 'Email not found'}
            </span>
          </div>
          <span className="f-roboto-secondary fs-0_75rem">
            {formatFullDateTime(chat?.createdAt)}
          </span>
        </div>
      </div>
      <div className="d-flex-start-start pt-1rem w-100">
        <p className="ff-roboto c-696974 fs-0_875rem lh-1_5rem ls-0_00625rem">
          {chat?.summary ? (
            chat?.summary
          ) : (
            <>
              {typeof chat?.lastMessage === 'object' &&
                'text' in chat.lastMessage
                ? chat.lastMessage.text
                : chat?.lastMessage}
            </>
          )}
        </p>
      </div>
    </div>
  );
};

export default ConversationCard;
